export const ProfileSymbols = {
    ProfileService: Symbol.for("ProfileService"),
    ProfileProvider: Symbol.for("ProfileProvider")
}